import { Components } from '@mui/material'

export function OverridedSnackbar(): Components {
  return {
    MuiSnackbar: {
      defaultProps: {
        anchorOrigin: {
          horizontal: 'center',
          vertical: 'bottom',
        },
      },
    },
  }
}
